


















import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import rulesMixin from './rulesMixin'

@Component({
	components: {},
})
export default class UsersList extends Mixins(rulesMixin) {
	@Prop({})
	private orderNo!: string

	public async getForm() {
		const obj: any = {
			reviewRule: {},
		}
		const list = (await this.getRuleList()) as any[]

		// list为多个rangeForm的二维数组，原本可添加多个rangeForm
		obj.reviewRule.ruleList = list[0]
		return Promise.resolve(obj)
	}
}
